import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchMyTrainingSchedule, formatTrainingDate, formatTrainingWindow } from '../api/trainingService';

/** Dashboard card for planters enrolled in a training semester; renders nothing otherwise. */
const NextTrainingCard: React.FC = () => {
  const { data } = useQuery({ queryKey: ['my-training'], queryFn: fetchMyTrainingSchedule });
  if (!data) return null;
  const next = data.sessions.find((s) => s.status !== 'cancelled' && new Date(s.endsAt) > new Date());
  return (
    <div className="bg-white shadow-lg rounded-xl p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Training</h2>
      {next ? (
        <>
          <p className="text-sm text-gray-500">Next session</p>
          <p className="text-gray-900 font-medium">{next.displayTitle}</p>
          <p className="text-sm text-gray-600">
            {formatTrainingDate(next.startsAt, next.timezone)} · {formatTrainingWindow(next.startsAt, next.endsAt, next.timezone)}
            {next.venue ? ` · ${next.venue.name}` : ''}
          </p>
        </>
      ) : (
        <p className="text-sm text-gray-600">No upcoming sessions.</p>
      )}
      <p className="text-sm text-gray-600 mt-2">Attended {data.summary.attended} of {data.summary.required} required sessions.</p>
      <div className="mt-4">
        <Link to="/training" className="inline-flex items-center px-4 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700">View schedule</Link>
      </div>
    </div>
  );
};

export default NextTrainingCard;
